module.exports = __webpack_public_path__ + "img/BPPMP1.fb135860.png";